export const LFO = 'LFO';
export const ENVELOPE = 'ENV';
